import React from 'react'
import { MainWorkspaceUnauthorized } from '../MainWorkspace'
import { RequireAuth } from './RequireAuth'
import { useSelector } from 'react-redux'
import { IStore } from '../../store/types'
import { CHANNELS_ID } from '../../utils/consts'

interface Props {
  element: JSX.Element
}

export const Unauthorized: React.FC<Props> = ({ element }) => {
  const { users } = useSelector((store: IStore) => store)

  if (
    (users.user && !users.user.channels.includes(String(CHANNELS_ID.UNAUTHORIZED))) ||
    (users.user && !users.user.approved_unauthorized)
  ) {
    return null
  }

  return (
    <RequireAuth>
      <MainWorkspaceUnauthorized>{element}</MainWorkspaceUnauthorized>
    </RequireAuth>
  )
}
